export interface LabelPoint { x: number; y: number }

/** Place badges in screen pixels, so zooming out cannot collapse them together. */
export function separateRouteLabels(anchors: LabelPoint[], width: number, height: number): LabelPoint[] {
  const placed: LabelPoint[] = [];
  const clamp = (p: LabelPoint) => ({ x: Math.max(26, Math.min(width - 26, p.x)), y: Math.max(26, Math.min(height - 26, p.y)) });
  for (const anchor of anchors) {
    let best = clamp(anchor);
    let found = false;
    for (let radius = 0; radius <= Math.max(width, height) && !found; radius += 56) {
      for (let step = 0; step < (radius ? 16 : 1); step++) {
        const angle = step * Math.PI / 8;
        const candidate = clamp({ x: anchor.x + radius * Math.cos(angle), y: anchor.y + radius * Math.sin(angle) });
        if (placed.every(p => Math.hypot(p.x - candidate.x, p.y - candidate.y) >= 52)) {
          best = candidate; found = true; break;
        }
      }
    }
    placed.push(best);
  }
  return placed;
}
